module.exports = __webpack_public_path__ + "img/bagna_cauda.64e1948f.jpg";